<div app-landing-page-section-container class="items-center">
    <div class="flex flex-col items-center text-white max-w-[900px]">
        <translate class="text-headline-5 content-text text-center">
            LandingPageDemoRequestTitle
        </translate>
        <translate
            class="content-text text-lg md:text-xl xl:text-xl mt-4 md:mt-8 text-center"
        >
            LandingPageDemoRequestText
        </translate>
        <div class="flex flex-col items-center">
            <app-landing-page-go-to-register
                class="mt-10"
            ></app-landing-page-go-to-register>
        </div>
    </div>
</div>
